(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MocoolkaFunction", [], factory);
	else if(typeof exports === 'object')
		exports["MocoolkaFunction"] = factory();
	else
		root["MocoolkaFunction"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition